import { ProcessStatusType } from "@/@types/general";
import React, { FormEvent, useState } from "react";
import { FaFile, FaFileImport } from "react-icons/fa6";
import ButtonLoader from "../ButtonLoader";

type Props = {
  onUpload: () => Promise<boolean>;
};

const FormUpload = (params: Props) => {
  const [status, setStatus] = useState<ProcessStatusType>("");

  const handleUpload = async (e: FormEvent) => {
    setStatus("loading");

    const isSuccess = await params.onUpload();
    setTimeout(() => {
      if (!isSuccess) {
        setStatus("error");
        return;
      }
      setStatus("success");
    }, 3000);
  };

  return null;
  return (
    <>
      <input type="file" hidden onChange={handleUpload} id="upload-file" />
      <label
        htmlFor="upload-file"
        className="btn btn-success transition-all btn-sm text-white"
      >
        {status == "loading" ? (
          <ButtonLoader />
        ) : (
          <>
            Import <FaFileImport />
          </>
        )}
      </label>
    </>
  );
};

export default FormUpload;
